export default (state = '', { type, payload }) => {
  switch (type) {
    case 'IS_HUNTPLANNER_DISABLE':
      return true
    case 'IS_HUNTPLANNER_ENABLE':
      return false
    case 'LOGOUT':
      return null
    default:
      return state
  }
}